






































































































































































































import Component from 'vue-class-component'
import CollectionSharedFunctions from '../CollectionSharedFunctions'
import Icon from '@/components/Icon.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import Select from '@/components/Select.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import { ISelectItem } from '@/interfaces'
import {
  EFacilityBlockableFeatures,
  ICollectionTask,
  IResident,
  IUser
} from '@zunta/configurations'
import CollectionActionSchedule
  from './actions/CollectionActionSchedule.vue'
import CollectionActionCall from '@/views/app/management/collections/components/actions/CollectionActionCall.vue'
import CollectionActionEscalate
  from './actions/CollectionActionEscalate.vue'
import Switcher from '@/components/Switcher.vue'
import CollectionActionPostpone
  from './actions/CollectionActionPostpone.vue'
import CollectionActionMail
  from './actions/CollectionActionMail.vue'
import Confirm from '@/components/Confirm.vue'
import DropdownNav from '@/components/DropdownNav.vue'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'

@Component({
  components: {
    DropdownNav,
    Confirm,
    CollectionActionMail,
    CollectionActionPostpone,
    Switcher,
    CollectionActionEscalate,
    CollectionActionCall,
    CollectionActionSchedule,
    Icon,
    Select,
    TextArea,
    DateInput
  }
})
export default class CollectionActions extends CollectionSharedFunctions {
  newTask: Partial<ICollectionTask> = {}
  sendMailTemplate: number = 0
  selectedAction: string = ''
  showConfirmExcludeFromCollections: boolean = false
  overflowHidden: boolean = true

  mounted () {
    this.$watch('$route', () => {
      this.selectedAction = ''
    })
  }

  get paymentRoutes () {
    const options = [
      {
        value: {
          name: 'payment-one-time',
          params: {
            residentId: this.selectedResident.id
          },
          query: {
            collectionReviewLink: `${this.type}.${(this.collectionTasks[this.currentTaskIndex].resident as IResident).id.toString()}`
          }
        },
        key: 'payment-one-time',
        content: 'One time'
      }
    ]

    if (this.user.hasPermissionFor(this.EUserPermissions.CREATE_AUTOPAY)) {
      options.push({
        value: {
          name: 'payment-autopay',
          params: {
            residentId: this.selectedResident.id
          },
          query: {
            collectionReviewLink: `${this.type}.${(this.collectionTasks[this.currentTaskIndex].resident as IResident).id.toString()}`
          }
        },
        key: 'payment-autopay',
        content: 'Autopay'
      })
    }
    return options
  }

  setOverflow (value: boolean) {
    this.overflowHidden = value
  }

  closeConfirmExclude () {
    this.showConfirmExcludeFromCollections = false
  }

  openConfirmExclude () {
    this.showConfirmExcludeFromCollections = true
  }

  setSelectedAction (action: string) {
    this.newTask = {
      assignedUser: this.selectedTask ? this.selectedTask.assignedUser.id : null
    }
    if (action === this.selectedAction) {
      return
    }
    if (this.selectedAction.length) {
      this.selectedAction = ''
      setTimeout(() => {
        this.selectedAction = action
      }, 200)
    } else {
      this.selectedAction = action
    }
    this.sendMailTemplate = 0
  }

  validateSendMailToResident () {
    if (!this.newTask.contactToCall) {
      return false
    }
    return this.sendMailTemplate !== 0
  }

  goPayment (route: object) {
    this.$locationManager.rememberAndGoTo(route)
  }

  async changeSelectedTaskAssignedUser (item: ISelectItem) {
    const response = await this.residentModuleInstance.changeCollectionTaskAssignedUser({
      collectionTaskId: this.selectedTask.id,
      assignedUserId: item.value,
      assignedUserData: this.usersList.find((user: IUser) => user.id === item.value),
      facilityId: typeof this.selectedResident.facility === 'number' ? this.selectedResident.facility : this.selectedResident.facility.id,
      residentId: Number(this.residentId),
      currentUserId: this.$store.state.user.user.id
    })
    if (response === 'OK') {
      this.notifySuccess('Collection Assigned User Changed')
      this.$eventBus.$emit('CollectionView:loadHistory', this.residentId)
      // await this.fetchResidentHistory()
    } else {
      this.notifyError()
    }
  }

  async sendActionRequest ({ functionName, successMessage, payloadData }: any) {
    // @ts-ignore
    if (!this.residentModuleInstance[functionName]) {
      console.error(`${functionName} is not a function`)
      return
    }
    const payload = {
      residentId: this.residentId,
      data: {
        assignedUser: this.selectedTask.assignedUser.id,
        facility: typeof this.selectedResident.facility === 'number' ? this.selectedResident.facility : this.selectedResident.facility.id,
        ...payloadData
      }
    }
    // @ts-ignore
    const response = await this.residentModuleInstance[functionName](payload)
    if (response === 'OK') {
      this.notifySuccess(successMessage)
      this.setSelectedAction('')
      this.$eventBus.$emit('CollectionView:loadHistory', this.residentId)
      // await this.fetchResidentHistory()
    } else {
      this.notifyError()
    }
  }

  async updateResidentExcluded () {
    this.closeConfirmExclude()
   this.$eventBus.$emit('loading:enable', { message: 'Loading...' })
    const exclude: boolean = !this.selectedTask.resident['excludeFromCollections']
    // this.selectedTask.resident['excludeFromCollections'] = exclude
    await this.changeResidentSetting('excludeFromCollections', exclude)
    await this.goNextTask()
    await this.residentModuleInstance.fetchCollectionTasksByFilters({
      type: this.type === 'today' ? 'today' : 'all',
      active: true
    })
  }

  notifySuccess (message: string) {
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: message,
      header: 'Collection Task',
      icon: 'warning'
    })
  }

  notifyError () {
    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Something went wrong',
      header: 'Collection Task',
      icon: 'warning'
    })
  }

  get isStatementGenAndMailBlocked () {
    return !this.selectedTaskFacility || isFacilityFeatureBlocked(this.selectedTaskFacility, EFacilityBlockableFeatures.MailAndGenStatements)
  }
}
